export function initDataColourPicker() {
    document.querySelectorAll<HTMLInputElement>('[data-colour-picker]').forEach(picker => {
        const text = <HTMLInputElement>picker.nextElementSibling;

        const show = () => {
            const value = text.value.trim() ? expand(text.value.trim()) : picker.defaultValue;
            if (value)
                picker.value = value;
        };

        picker.addEventListener('input', () => text.value = picker.value);
        text.addEventListener('input', show);
        show();
    });

    function expand(value: string) {
        if (/^#[0-9a-f]{6}$/i.test(value))
            return value.toLowerCase();

        if (/^#[0-9a-f]{3}$/i.test(value))
            return '#' + value.slice(1).split('').map(x => x + x).join('').toLowerCase();

        return null;
    }
}
